import AccountBalanceWallet from '@material-ui/icons/AccountBalanceWalletOutlined';
import AddCircle from '@material-ui/icons/AddCircleOutlined';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import Business from '@material-ui/icons/BusinessOutlined';
import Call from '@material-ui/icons/CallOutlined';
import DashboardIcon from '@material-ui/icons/Dashboard';
import Email from '@material-ui/icons/EmailOutlined';
import ListOutlinedIcon from '@material-ui/icons/ListOutlined';
import People from '@material-ui/icons/PeopleOutline';
import PhonelinkRing from '@material-ui/icons/PhonelinkRingOutlined';
import Receipt from '@material-ui/icons/ReceiptOutlined';
import Restore from '@material-ui/icons/Restore';
import DockOutlined from '@material-ui/icons/DockOutlined';
import Subtitles from '@material-ui/icons/Subtitles';
import BillingPaymentTrackIcon from 'assets/img/icons/BillingPaymentTrack';
import MyServices from 'assets/img/icons/MyServices';
import NewServices from 'assets/img/icons/NewServices';
import PayAnyBillIcon from 'assets/img/icons/PayAnyBill';
import PrepaidLoyaltyIcon from 'assets/img/icons/PrepaidLoyalty';
import { ReactComponent as QueriesAndComplaintsIcon } from 'assets/img/icons/queries_and_complaints_sidebar.svg';
import TryAndBuyIcon from 'assets/img/icons/TryAndBuyIcon';
import { hasPermission } from 'utils/permissions/permissions';
import ActiveServices from 'views/ActiveServices';
import Activities from 'views/Activities';
import AddNewServices from 'views/AddNewServices';
import BillingPaymentTrack from 'views/BillingPaymentTrack';
import Bills from 'views/Bills';
import BulkPurchaseDevices from 'views/BulkPurchaseDevices';
import ContactUs from 'views/ContactUs';
import Dashboard from 'views/Dashboard';
import ErrorPage from 'views/ErrorPage';
import HistoryOfComplaints from 'views/HistoryOfComplaints';
import Numbers from 'views/Numbers';
import Organizations from 'views/Organizations';
import PaymentsHistory from 'views/PaymentsHistory';
import PrepaidLoyalty from 'views/PrepaidLoyalty';
import TryAndBuy from 'views/TryAndBuy';
import Users from 'views/Users';
import UsersServiceRequests from 'views/UsersServiceRequests';
import Wallet from 'views/Wallet';
import TopUp from 'views/TopUp';
import PaymentRequestStatusBOM from 'views/PaymentRequestStatusBOM';
import PayAnyBill from 'views/Bills/PayAnyBill';
import { UserGuideURL } from 'config/app.config';
import { isNewHeaderOn } from 'utils/killswitch';

interface IDashRoutesProps {
	accountType: types.routes.accountType;
	userType: string;
	remoteConfig: any;
}

export const dashRoutes = ({
	accountType,
	userType,
	remoteConfig,
}: IDashRoutesProps): types.routes.ISingleDashboardRoute[] => {
	const isNewHeaderVisible = isNewHeaderOn(remoteConfig);
	return isNewHeaderVisible
		? ([
				{
					path: '/summary',
					name: 'dashboard',
					icon: 'chartInfo',
					component: Dashboard,
					layout: '/dashboard',
					visible: true,
				},
				{
					path: '/organizations',
					name: accountType === 'ENTERPRISE' ? 'myOrganizations' : 'myOrganization',
					component: Organizations,
					layout: '/dashboard',
					visible: false,
				},
				{
					name: 'subscription',
					icon: 'tap',
					path: '',
					layout: '/dashboard',
					collapse: true,
					state: 'servicesCollapse',
					visible: true,
					views: [
						{
							path: '/numbers',
							name: 'myNumbers',
							component: Numbers,
							layout: '/dashboard',
							icon: Call,
							collapseItem: true,
							visible: true,
						},
						hasPermission(userType, 'services:active_services') && {
							path: '/active-services',
							name: 'myActiveServices',
							component: ActiveServices,
							icon: PhonelinkRing,
							collapseItem: true,
							layout: '/dashboard',
						},
						hasPermission(userType, 'services:add_services') && {
							path: '/services',
							name: 'newServices',
							icon: NewServices,
							layout: '/dashboard',
							component: AddNewServices,
							visible: true,
							collapseItem: true,
						},
						hasPermission(userType, 'services:purchase_device') &&
							remoteConfig?.sidebar?.bulkPurchase && {
								path: '/purchase-bulk-devices',
								name: 'purchaseBulkDevices',
								component: BulkPurchaseDevices,
								layout: '/dashboard',
								visible: true,
								icon: AddShoppingCartIcon,
								collapseItem: true,
							},

						hasPermission(userType, 'services:try_and_buy') && {
							name: 'tryAndBuy',
							path: '/try-and-buy',
							icon: TryAndBuyIcon,
							component: TryAndBuy,
							layout: '/dashboard',
							visible: false,
						},
						hasPermission(userType, 'services:prepaid_loyalty') &&
							remoteConfig?.sidebar?.prepaidLoyalty && {
								name: 'prepaidLoyalty',
								path: '/gift-program',
								icon: PrepaidLoyaltyIcon,
								component: PrepaidLoyalty,
								layout: '/dashboard',
								visible: false,
							},
					].filter(Boolean),
				},
				hasPermission(userType, 'payment:bills') && {
					path: '/bills',
					name: 'bills',
					layout: '/dashboard',
					component: Bills,
					visible: true,
					icon: 'billing',
				},
				hasPermission(userType, 'payment:pay_bills') && {
					name: 'billing',
					icon: 'billing',
					path: '',
					layout: '/dashboard',
					collapse: true,
					visible: true,
					state: 'paymentsCollapse',
					views: [
						{
							path: '/payments/pay-any-bill',
							name: 'payAnyBill',
							component: PayAnyBill,
							layout: '/dashboard',
							visible: true,
							icon: PayAnyBillIcon,
							collapseItem: true,
						},
						{
							path: '/payments/topup',
							params: '/:phoneNumberEncoded?',
							name: 'topup',
							component: TopUp,
							layout: '/dashboard',
							visible: true,
							icon: AddCircle,
							collapseItem: true,
						},
						{
							path: '/payments/bills',
							name: 'myBills',
							component: Bills,
							layout: '/dashboard',
							visible: true,
							icon: Receipt,
							collapseItem: true,
						},
						remoteConfig?.sidebar?.bankMuscat && {
							path: '/payments/payments-requests',
							name: 'myPaymentRequest',
							layout: '/dashboard',
							visible: true,
							component: PaymentRequestStatusBOM,
							icon: Restore,
							collapseItem: true,
						},
						{
							path: '/payments/payments-receipts',
							name: remoteConfig?.sidebar?.bankMuscat ? 'myPaymentsReceipts' : 'myPaymentsHistory',
							layout: '/dashboard',
							visible: true,
							component: PaymentsHistory,
							icon: remoteConfig?.sidebar?.bankMuscat ? DockOutlined : Restore,
							collapseItem: true,
						},
						remoteConfig?.sidebar?.billingPaymentTrack && {
							path: '/payments/billing-payment-track',
							name: 'billingPaymentTrack',
							layout: '/dashboard',
							visible: true,
							component: BillingPaymentTrack,
							icon: BillingPaymentTrackIcon,
							collapseItem: true,
						},
						{
							path: '/payments/wallet',
							name: 'myWallet',
							layout: '/dashboard',
							visible: true,
							component: Wallet,
							icon: AccountBalanceWallet,
							collapseItem: true,
						},
					].filter(Boolean),
				},
				hasPermission(userType, 'insights') &&
					remoteConfig?.sidebar?.enableInsights && {
						name: 'insights',
						layout: '',
						visible: true,
						collapse: true,
						icon: 'calender',
						path: '#',
						views: [],
						customPath: '/alpha/insights',
					},
				{
					name: 'settings',
					layout: '/dashboard',
					visible: true,
					collapse: true,
					icon: 'settings',
					isHiddenDesktop: true,
					path: '',
					views: [
						{
							path: '/users',
							name: 'myUsers',
							component: Users,
							layout: '/dashboard',
							visible: true,
							icon: People,
						},
						{
							path: '/organizations',
							name: accountType === 'ENTERPRISE' ? 'myOrganizations' : 'myOrganization',
							icon: Business,
							component: Organizations,
							layout: '/dashboard',
							visible: true,
						},
					],
				},
				{
					path: '/list-of-activities',
					name: 'listOfActivities',
					layout: '/dashboard',
					component: Activities,
					visible: false,
					icon: ListOutlinedIcon,
				},
				{
					path: '/history-of-complaints',
					name: 'historyOfComplaints',
					layout: '/dashboard',
					component: HistoryOfComplaints,
					visible: false,
					icon: QueriesAndComplaintsIcon,
				},
				{
					path: '',
					name: 'support',
					layout: '/dashboard',
					visible: true,
					icon: 'headphones',
					collapse: true,
					views: [
						{
							path: '/list-of-activities',
							name: 'listOfActivities',
							layout: '/dashboard',
							component: Activities,
							visible: true,
							icon: ListOutlinedIcon,
						},
						{
							path: '/history-of-complaints',
							name: 'historyOfComplaints',
							layout: '/dashboard',
							component: HistoryOfComplaints,
							visible: true,
							icon: QueriesAndComplaintsIcon,
						},
						hasPermission(userType, 'payment:service_requests') &&
							remoteConfig?.sidebar?.usersServiceRequests && {
								path: '/service-requests',
								name: 'usersServiceRequests',
								icon: Receipt,
								layout: '/dashboard',
								component: UsersServiceRequests,
								visible: true,
							},
						{
							path: '/contact-us',
							name: 'contactUs',
							layout: '/dashboard',
							icon: Receipt,
							component: ContactUs,
							visible: true,
						},
					].filter(Boolean),
				},
				remoteConfig?.sidebar?.userGuide && {
					name: 'help',
					visible: true,
					collapse: false,
					icon: 'questionMarkCircle',
					isHiddenDesktop: true,
					customPath: UserGuideURL,
				},
				remoteConfig?.sidebar?.isNewDashboardLinkEnabled && {
					path: '/alpha/dashboard',
					name: 'newDashboardLink',
					layout: '',
					customPath: '/alpha/dashboard',
					visible: true,
					icon: 'chartInfo',
				},
				{
					path: '/error-page',
					name: 'errorPage',
					layout: '/dashboard',
					component: ErrorPage,
				},
		  ].filter(Boolean) as types.routes.ISingleDashboardRoute[])
		: ([
				{
					path: '/summary',
					name: 'path.dashboard',
					icon: DashboardIcon,
					component: Dashboard,
					layout: '/dashboard',
					visible: true, // route is showed in sidebar
				},
				{
					path: '/organizations',
					name: accountType === 'ENTERPRISE' ? 'path.my.organizations' : 'path.my.organization',
					icon: Business,
					component: Organizations,
					layout: '/dashboard',
					visible: true,
				},
				{
					name: 'path.my.services',
					icon: MyServices,
					path: '',
					layout: '/dashboard',
					collapse: true,
					state: 'servicesCollapse',
					visible: true,
					views: [
						{
							path: '/numbers',
							name: 'path.my.numbers',
							component: Numbers,
							layout: '/dashboard',
							icon: Call,
							collapseItem: true,
							visible: true,
						},
						{
							path: '/users',
							name: 'path.my.users',
							component: Users,
							layout: '/dashboard',
							visible: true,
							icon: People,
							collapseItem: true,
						},
						hasPermission(userType, 'services:active_services') && {
							path: '/active-services',
							name: 'path.my.active.services',
							component: ActiveServices,
							icon: PhonelinkRing,
							collapseItem: true,
							layout: '/dashboard',
						},
						hasPermission(userType, 'services:add_services') && {
							path: '/services',
							name: 'path.new.services',
							icon: NewServices,
							layout: '/dashboard',
							component: AddNewServices,
							visible: true,
							collapseItem: true,
						},
						hasPermission(userType, 'services:purchase_device') &&
							remoteConfig?.sidebar?.bulkPurchase && {
								path: '/purchase-bulk-devices',
								name: 'path.purchase.bulk.devices',
								component: BulkPurchaseDevices,
								layout: '/dashboard',
								visible: true,
								icon: AddShoppingCartIcon,
								collapseItem: true,
							},
					].filter(Boolean),
				},
				hasPermission(userType, 'services:try_and_buy') && {
					name: 'path.try.and.buy',
					path: '/try-and-buy',
					icon: TryAndBuyIcon,
					component: TryAndBuy,
					layout: '/dashboard',
					visible: true,
				},
				hasPermission(userType, 'services:prepaid_loyalty') &&
					remoteConfig?.sidebar?.prepaidLoyalty && {
						name: 'path.prepaid.loyalty',
						path: '/gift-program',
						icon: PrepaidLoyaltyIcon,
						component: PrepaidLoyalty,
						layout: '/dashboard',
						visible: true,
					},
				hasPermission(userType, 'payment:bills') && {
					path: '/bills',
					name: 'path.bills',
					icon: Receipt,
					layout: '/dashboard',
					component: Bills,
					visible: true,
				},
				hasPermission(userType, 'payment:pay_bills') && {
					name: 'path.my.payments',
					icon: Subtitles,
					path: '',
					layout: '/dashboard',
					collapse: true,
					visible: true,
					state: 'paymentsCollapse',
					views: [
						{
							path: '/payments/pay-any-bill',
							name: 'path.pay.any.bill',
							component: PayAnyBill,
							layout: '/dashboard',
							visible: true,
							icon: PayAnyBillIcon,
							collapseItem: true,
						},
						{
							path: '/payments/topup',
							params: '/:phoneNumberEncoded?',
							name: 'path.topup',
							component: TopUp,
							layout: '/dashboard',
							visible: true,
							icon: AddCircle,
							collapseItem: true,
						},
						{
							path: '/payments/bills',
							name: 'path.my.bills',
							component: Bills,
							layout: '/dashboard',
							visible: true,
							icon: Receipt,
							collapseItem: true,
						},
						remoteConfig?.sidebar?.bankMuscat && {
							path: '/payments/payments-requests',
							name: 'path.my.payment.request',
							layout: '/dashboard',
							visible: true,
							component: PaymentRequestStatusBOM,
							icon: Restore,
							collapseItem: true,
						},
						{
							path: '/payments/payments-receipts',
							name: 'path.my.payments.receipts',
							layout: '/dashboard',
							visible: true,
							component: PaymentsHistory,
							icon: remoteConfig?.sidebar?.bankMuscat ? DockOutlined : Restore,
							collapseItem: true,
						},
						remoteConfig?.sidebar?.billingPaymentTrack && {
							path: '/payments/billing-payment-track',
							name: 'path.billing.payment.track',
							layout: '/dashboard',
							visible: true,
							component: BillingPaymentTrack,
							icon: BillingPaymentTrackIcon,
							collapseItem: true,
						},
						{
							path: '/payments/wallet',
							name: 'path.my.wallet',
							layout: '/dashboard',
							visible: true,
							component: Wallet,
							icon: AccountBalanceWallet,
							collapseItem: true,
						},
					].filter(Boolean),
				},
				{
					path: '/list-of-activities',
					name: 'path.list.of.activities',
					layout: '/dashboard',
					component: Activities,
					visible: true,
					icon: ListOutlinedIcon,
				},
				{
					path: '/history-of-complaints',
					name: 'path.history.of.complaints',
					layout: '/dashboard',
					component: HistoryOfComplaints,
					visible: true,
					icon: QueriesAndComplaintsIcon,
				},
				hasPermission(userType, 'payment:service_requests') &&
					remoteConfig?.sidebar?.usersServiceRequests && {
						path: '/service-requests',
						name: 'path.users.service.requests',
						icon: Receipt,
						layout: '/dashboard',
						component: UsersServiceRequests,
						visible: true,
					},
				{
					path: '/contact-us',
					name: 'path.contact.us',
					layout: '/dashboard',
					component: ContactUs,
					visible: true,
					icon: Email,
				},
				{
					path: '/error-page',
					name: 'path.error.page',
					layout: '/dashboard',
					component: ErrorPage,
				},
		  ].filter(Boolean) as types.routes.ISingleDashboardRoute[]);
};
